<template>
  <div>
    <h1 class="page-header">{{ $t('paymentannouncement.announcement') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('paymentannouncement.mainProgram') }}</label>
              <ts-search-select v-model.number="model.acp_id" :options="mainPrograms"
                @change="onMainProgramChange"></ts-search-select>
              <div class="validate" v-if="errors.has('acp_id')">
                {{ errors.first('acp_id') }}
              </div>
              <small>
                <i>{{
                  $t(
                    'paymentannouncement.chooseanymainprogramstodisplaysubprogramsand'
                  )
                }}</i>
              </small>
            </div>

            <div class="form-group m-b-15">
              <label>
                {{ $t('paymentannouncement.subProgram') }}
                <span class="text-danger">*</span>
                <i class="fas fa-spinner spin" v-if="main_program_change"></i>
              </label>
              <a-select v-model="model.acps_id_list" placeholder="--Select--" style="width: 100%" mode="multiple"
                :allow-clear="true" :loading="main_program_change" :disabled="!model.acp_id" option-label-prop="label"
                @change="onSubChange">
                <a-select-option v-for="sub in subPrograms" :key="sub.value" :value="sub.value" :label="sub.label">
                  {{ sub.label }}
                </a-select-option>
              </a-select>
              <div class="validate" v-if="errors.has('acps_id_list')">
                {{ errors.first('acps_id_list') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>
                {{ $t('paymentannouncement.grade') }}
              </label>
              <a-select v-model="model.grade_id_list" mode="multiple" style="width: 100%" :placeholder="$t('all')"
                :max-tag-count="1" :max-tag-text-length="10" :options="grades" :filterOption="(input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                  "></a-select>
            </div>
            <div class="validate" v-if="errors.has('grade_id_list')">
              {{ errors.first('grade_id_list') }}
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.startDate')
              }}</label>
              <ts-date-picker-input v-model="model.start_date" :closeOnSelect="true"></ts-date-picker-input>
              <div class="validate" v-if="errors.has('start_date')">
                {{ errors.first('start_date') }}
              </div>
            </div>

            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.dueDate')
              }}</label>
              <ts-date-picker-input v-model="model.payment_due_date" :closeOnSelect="true"></ts-date-picker-input>
              <div class="validate" v-if="errors.has('payment_due_date')">
                {{ errors.first('payment_due_date') }}
              </div>
            </div>


            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.endDate')
              }}</label>
              <ts-date-picker-input v-model="model.end_date" :closeOnSelect="true"></ts-date-picker-input>
              <div class="validate" v-if="errors.has('end_date')">
                {{ errors.first('end_date') }}
              </div>
            </div>



            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button v-if="updating" class="btn-primary" :waiting="waiting" @click.prevent="update">{{ $t('update')
              }}</ts-button>
              <ts-button v-if="!updating" :waiting="waiting" class="btn-primary" @click.prevent="store">{{ $t('save')
              }}</ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>

      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import DataTable from './table'
import moment from 'moment'

export default {
  name: 'payment-announcement-form',
  components: { DataTable },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      main_program_change: false,
      subprogram: false,
      grades: [],
      model: {
        acp_id: null,
        acps_id_list: [],
        start_date: '',
        end_date: '',
        payment_due_date: '',
        announcement_criteria: '',
        reminder_criteria: '',
        grade_id_list: []
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('paymentAnnouncement', ['edit_data']),
    mainPrograms() {
      return this.$store.state.paymentAnnouncement.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    subPrograms() {
      return this.$store.state.paymentAnnouncement.sub_programs.map(el => ({
        value: el.acps_id,
        label: el.acps_name_foreign
      }))
    }
  },
  methods: {
    ...mapActions('paymentAnnouncement', ['getGrade']),

    async onMainProgramChange() {
      if (!this.model.acp_id) {
        this.main_program_change = false
        return
      }
      this.main_program_change = true
      this.model.acps_id_list = []
      await this.$store.dispatch(
        'paymentAnnouncement/getSubProgram',
        this.model.acp_id
      )
      this.main_program_change = false
    },
    buildPayload() {
      const acpsList = this.model.acps_id_list.filter(v => v !== null)
      const gradeList = this.model.grade_id_list.filter(v => v !== null)

      return {
        ...this.model,
        acps_id_list: acpsList.length ? acpsList.join(',') : null,
        grade_id_list: gradeList.length ? gradeList.join(',') : '0'
      }
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('paymentAnnouncement/store', this.buildPayload())
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('paymentAnnouncement/update', this.buildPayload())
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    cancel() {
      this.updating = false
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', {})
      this.$router.push({ name: 'payment-announcement' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.main_program_change = true
        await this.$store.dispatch(
          'paymentAnnouncement/getSubProgram',
          this.edit_data.acp_id
        )

        // ✅ Also fetch grades for the existing sub programs on edit
        if (this.edit_data.acps_id_list && this.edit_data.acps_id_list.length) {
          await this.onSubChange(this.edit_data.acps_id_list)
        }

        this.model = {
          ..._.clone(this.edit_data),
          acps_id_list: Array.isArray(this.edit_data.acps_id_list)
            ? this.edit_data.acps_id_list : [],
          grade_id_list: Array.isArray(this.edit_data.grade_id_list)  // ✅ was grade_id
            ? this.edit_data.grade_id_list : []
        }
        this.updating = true
        this.main_program_change = false
      }
    },
    clearInput() {
      this.model = {
        acp_id: null,
        acps_id_list: [],
        start_date: '',
        end_date: '',
        payment_due_date: '',
        announcement_criteria: '',
        reminder_criteria: '',
        grade_id_list: [],
      }
    },

    async onSubChange(acps_id) {
      if (!acps_id || (Array.isArray(acps_id) && acps_id.length === 0)) {
        this.grades = [];
        this.model.grade_id_list = [];
        return;
      }

      this.waiting = true;
      try {
        const response = await this.getGrade({ acps_id: acps_id });

        if (response && response.data) {
          let mappedData = response.data.map(el => ({
            value: el.grade_id,
            label: String(el.grade_name_foreign || ''),
            key: el.grade_id
          }));
          mappedData.sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })
          );

          this.grades = mappedData;
        } else {
          this.grades = [];
        }
      } catch (error) {
        this.$toasted.error(error.message);
      } finally {
        this.waiting = false;
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    },
    // 'model.start_date': {
    //   handler(newValue) {
    //     if (this.updating) return
    //     if (!newValue || newValue === '') return
    //     let startDate = moment(newValue, 'DD-MM-YYYY', true)
    //     if (!startDate.isValid())
    //       startDate = moment(newValue, 'YYYY-MM-DD', true)
    //     if (!startDate.isValid()) startDate = moment(newValue)
    //     if (startDate.isValid()) {
    //       this.model.end_date = startDate
    //         .clone()
    //         .add(1, 'day')
    //         .format('DD-MM-YYYY')
    //     }
    //   },
    //   immediate: false
    // }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('paymentAnnouncement/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
